import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const AlertDeleteModal = (prop) => {
    return (
        <>
        <Modal show={prop.showModal} onHide={prop.handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Delete Merch Alert</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <p>Are you sure you want to delete this merch alert? <br /> Once it gets deleted, app users will not be able to see it.</p>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="primary" onClick={prop.handleClose}>CANCEL</Button>
            <Button variant="primary" onClick={prop.handleAlertDelete}>CONFIRM</Button>
            </Modal.Footer>
        </Modal>
        </>
    );
};

export default AlertDeleteModal;